module.exports = __webpack_public_path__ + "static/media/thermostatLarge_160.c3fb0655.png";